import { useCallback, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const API_BASE_URL = process.env.REACT_APP_PERMISSIONS_API || '';

export const useManageAccessAdmin = () => {
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  const getAuthHeaders = useCallback(async () => {
    const token = await getAccessTokenSilently();

    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }, [getAccessTokenSilently]);

  const refreshAdminStatus = useCallback(async () => {
    if (!isAuthenticated || !user?.email) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const headers = await getAuthHeaders();
      const response = await fetch(`${API_BASE_URL}/api/access/admin-status`, {
        headers,
      });

      if (!response.ok) {
        setIsAdmin(false);
        return;
      }

      const result = await response.json();
      setIsAdmin(result?.isAdmin === true);
    } catch {
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, user?.email, getAuthHeaders]);

  useEffect(() => {
    refreshAdminStatus();
  }, [refreshAdminStatus]);

  return {
    isAdmin,
    loading,
    getAuthHeaders,
    refreshAdminStatus,
  };
};

export default useManageAccessAdmin;
